(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3299],{

/***/ 64078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(60531)


/***/ }),

/***/ 69032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51776);

var useSetState = function (initialState) {
    if (initialState === void 0) { initialState = {}; }
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState), state = _a[0], set = _a[1];
    var setState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (patch) {
        set(function (prevState) {
            return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
        });
    }, []);
    return [state, setState];
};
/* harmony default export */ __webpack_exports__["Z"] = (useSetState);


/***/ }),

/***/ 60531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(81547)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(7185)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(51776));
var _loadable = _interop_require_default(__webpack_require__(87843));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 14274:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(7185)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(51776));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 87843:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(81547)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(85549)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(51776));
var _loadableContext = __webpack_require__(14274);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 8529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ CardAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const CardAds = ({ className ="" , style ={
    display: "block"
} , clientId ="ca-pub-9455978208365758" , slotId , layout ="" , layoutKey ="" , format ="auto" , responsive ="false" , pageLevelAds =false , adTest , children , ...props })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // === TEMPORARY NOT USED BY ===
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        try {
            //@ts-ignore
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return(//@ts-ignore
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "card-ads",
        id: props?.id || router.asPath,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
            className: "adsbygoogle",
            "data-ad-client": "ca-pub-9455978208365758",
            "data-ad-slot": slotId,
            "data-ad-format": "auto",
            "data-full-width-responsive": "true",
            style: {
                display: "block"
            }
        })
    }, props?.key || router.asPath));
};


/***/ }),

/***/ 59542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ IconTimer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51776);


const IconTimer = ({ size =12 , color ="#5D586C" , classes =""  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "fill-neutral-60",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M6 1C5.0111 1 4.0444 1.29324 3.22215 1.84265C2.39991 2.39206 1.75904 3.17295 1.3806 4.08658C1.00217 5.00021 0.90315 6.00555 1.09608 6.97545C1.289 7.94536 1.76521 8.83627 2.46447 9.53553C3.16373 10.2348 4.05465 10.711 5.02455 10.9039C5.99446 11.0969 6.99979 10.9978 7.91342 10.6194C8.82705 10.241 9.60794 9.6001 10.1573 8.77785C10.7068 7.95561 11 6.98891 11 6C11 5.34339 10.8707 4.69321 10.6194 4.08658C10.3681 3.47995 9.99983 2.92876 9.53554 2.46447C9.07124 2.00017 8.52005 1.63188 7.91342 1.3806C7.30679 1.12933 6.65661 1 6 1V1ZM6 10C5.20888 10 4.43552 9.7654 3.77772 9.32588C3.11992 8.88635 2.60723 8.26164 2.30448 7.53073C2.00173 6.79983 1.92252 5.99556 2.07686 5.21964C2.2312 4.44371 2.61217 3.73098 3.17158 3.17157C3.73099 2.61216 4.44372 2.2312 5.21964 2.07686C5.99557 1.92252 6.79983 2.00173 7.53074 2.30448C8.26164 2.60723 8.88635 3.11992 9.32588 3.77772C9.76541 4.43552 10 5.20887 10 6C10 7.06087 9.57858 8.07828 8.82843 8.82843C8.07828 9.57857 7.06087 10 6 10V10ZM6 3C5.86739 3 5.74022 3.05268 5.64645 3.14645C5.55268 3.24021 5.5 3.36739 5.5 3.5V5.5H4.5C4.36739 5.5 4.24022 5.55268 4.14645 5.64645C4.05268 5.74021 4 5.86739 4 6C4 6.13261 4.05268 6.25979 4.14645 6.35355C4.24022 6.44732 4.36739 6.5 4.5 6.5H6C6.13261 6.5 6.25979 6.44732 6.35356 6.35355C6.44732 6.25979 6.5 6.13261 6.5 6V3.5C6.5 3.36739 6.44732 3.24021 6.35356 3.14645C6.25979 3.05268 6.13261 3 6 3Z"
        })
    });
};


/***/ }),

/***/ 5717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ModalShare; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36734);
/* harmony import */ var components_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59177);
/* harmony import */ var components_Toast_toastStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22505);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33906);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59799);
/* harmony import */ var components_Icon_IconSocial__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49765);
/* harmony import */ var components_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61097);







const ModalShare = ({ isShow , onClose , title , data , onClickShare , useModal =true , isSubdomain =false , isB2B =false , isMoodle =false , originalURL ="" , className =""  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const showToast = (0,components_Toast_toastStore__WEBPACK_IMPORTED_MODULE_2__/* .useToastStore */ .E)((state)=>state.showToast);
    const onCopyLink = ()=>{
        let temp = document.createElement("textarea");
        let url = window.location.href;
        temp.value = url;
        temp.id = "url-input";
        document.body.appendChild(temp);
        temp.select();
        document.execCommand("copy");
        temp.remove();
        onClose();
        showToast({
            type: "success",
            message: "Link berhasil disalin!"
        });
    };
    const onPushRoute = (link)=>{
        onClose();
    };
    const isDesktop = (0,lib_device__WEBPACK_IMPORTED_MODULE_4__/* .useIsDesktop */ .Ce)();
    const renderContent = (theme = "grid grid-cols-3 ")=>{
        if (isB2B || isMoodle) {
            const subdomainLink = data.length > 0 && data[4];
            const moodleLink = data.length > 0 && data[5];
            let inputValue = !isSubdomain ? moodleLink.href : subdomainLink.href;
            const originalURL = document.referrer;
            if (originalURL.includes("plus")) {
                inputValue = `https://gok-ares-enterprise-plus.learnext.ai/iframe?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("megainsurance")) {
                inputValue = `https://apps.megainsurance.co.id:8803/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("bogalearning")) {
                inputValue = `http://bogalearning.com/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("bersatulearning")) {
                inputValue = `https://bersatulearning.com/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("wlc")) {
                inputValue = `https://wlc.kemenparekraf.go.id/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("esdm")) {
                inputValue = `https://smile.esdm.go.id/lms/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("kemkes")) {
                inputValue = `https://kms.kemkes.go.id/gokampus?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("pupuk-indonesia")) {
                inputValue = `https://lms-dev.pupuk-indonesia.com/gokampus-library?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("sippa")) {
                inputValue = `https://sippa.kemenperin.go.id/jf/microlearning/ml/peserta?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("sijule")) {
                inputValue = `https://sijule-bpsdm.jakarta.go.id/?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("bps")) {
                inputValue = `https://lms.bps.go.id/local/gokampus/index.php?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("ioh")) {
                inputValue = `https://ide.ioh.co.id/academy/course?type=course&slug=${subdomainLink.slug}`;
            }
            if (originalURL.includes("gaji")) {
                inputValue = `https://member.gaji.id/gaji/#/fitur-extra/edukasi/go-kampus?type=course&slug=${subdomainLink.slug}`;
            }
            const unsecuredCopyToClipboard = (text)=>{
                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand("copy");
                } catch (err) {
                    console.error("Unable to copy to clipboard", err);
                }
                document.body.removeChild(textArea);
            };
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "h-36 flex",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "text",
                        className: "border border-neutral-40 rounded-8 h-full flex-1 px-12 mr-8",
                        value: inputValue,
                        disabled: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        onClick: ()=>{
                            if (!navigator.clipboard) {
                                unsecuredCopyToClipboard(inputValue);
                            } else {
                                navigator.clipboard.writeText(inputValue);
                            }
                            onClose();
                            showToast({
                                type: "success",
                                message: "Link berhasil disalin!"
                            });
                            if (onClickShare) {
                                onClickShare({
                                    id: "Copy Link"
                                });
                            }
                        },
                        children: "Salin Link"
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: theme || "",
            children: data && data.length > 0 && data.map((el)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    target: "_blank",
                    href: el.href && el.id !== "link" ? el.href : undefined,
                    onClick: ()=>{
                        if (onClickShare) {
                            onClickShare(el);
                        }
                        el.href && el.id !== "link" ? onPushRoute(el.href) : onCopyLink();
                    },
                    className: "cursor-pointer flex justify-center",
                    rel: "noopener noreferrer",
                    children: {
                        whatsapp: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconSocial__WEBPACK_IMPORTED_MODULE_5__/* .IconSocial */ .K, {
                                    icon: "wa"
                                }),
                                useModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-b2 text-neutral-70",
                                    children: el.label
                                })
                            ]
                        }),
                        instagram: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconSocial__WEBPACK_IMPORTED_MODULE_5__/* .IconSocial */ .K, {}),
                                useModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-b2 text-neutral-70",
                                    children: el.label
                                })
                            ]
                        }),
                        twitter: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconSocial__WEBPACK_IMPORTED_MODULE_5__/* .IconSocial */ .K, {
                                    icon: "twitter"
                                }),
                                useModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-b2 text-neutral-70",
                                    children: el.label
                                })
                            ]
                        }),
                        linkedin: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconSocial__WEBPACK_IMPORTED_MODULE_5__/* .IconSocial */ .K, {
                                    icon: "linkedin"
                                }),
                                useModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-b2 text-neutral-70",
                                    children: el.label
                                })
                            ]
                        }),
                        facebook: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconSocial__WEBPACK_IMPORTED_MODULE_5__/* .IconSocial */ .K, {
                                    icon: "fb"
                                }),
                                useModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-b2 text-neutral-70",
                                    children: el.label
                                })
                            ]
                        }),
                        link: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Icon_IconSocial__WEBPACK_IMPORTED_MODULE_5__/* .IconSocial */ .K, {
                                    icon: "link"
                                }),
                                useModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-b2 text-neutral-70",
                                    children: el.label
                                })
                            ]
                        })
                    }[el.id]
                }, el.id + "Shared"))
        });
    };
    if (useModal) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            color: "#000",
            title: title,
            isShow: isShow,
            onClose: onClose,
            children: renderContent("my-16 gap-10 flex justify-between")
        });
    } else {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `flex flex-row gap-20 items-center justify-end ${className}`,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text-b2 font-medium text-neutral-60",
                    children: "Bagikan : "
                }),
                renderContent("flex flex-row justify-end gap-12")
            ]
        });
    }
};


/***/ }),

/***/ 58486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ BlogArticleDetail; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(36734);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(51776);
// EXTERNAL MODULE: ./src/components/PageHeader/PageHeader.tsx + 1 modules
var PageHeader = __webpack_require__(28155);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(35824);
// EXTERNAL MODULE: ./src/modules/Blog/blogApi.ts
var blogApi = __webpack_require__(6153);
// EXTERNAL MODULE: ./src/lib/date.ts
var date = __webpack_require__(59647);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(33906);
// EXTERNAL MODULE: ./src/components/Icon/IconClose.tsx
var IconClose = __webpack_require__(84132);
;// CONCATENATED MODULE: ./src/components/Card/CardSticky.tsx



const CardSticky = ({ children , classes ="" , theme ="bg-neutral-80" , full , onClose  })=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed bottom-0 left-0 right-0 flex justify-center ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-[480px] relative " + (classes ? classes : "") + (full && theme ? ` ${theme}` : ""),
            children: [
                onClose && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: "ml-auto",
                    onClick: onClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                        size: 20
                    })
                }),
                children
            ]
        })
    });
};
/* harmony default export */ var Card_CardSticky = (CardSticky);

// EXTERNAL MODULE: ./src/components/Toast/toastStore.ts
var toastStore = __webpack_require__(22505);
// EXTERNAL MODULE: ./src/components/Card/CardAds.tsx
var CardAds = __webpack_require__(8529);
// EXTERNAL MODULE: ./src/components/Modal/ModalShare.tsx
var ModalShare = __webpack_require__(5717);
// EXTERNAL MODULE: ./src/lib/helper.ts
var helper = __webpack_require__(99601);
// EXTERNAL MODULE: ./src/lib/device.ts
var device = __webpack_require__(59799);
// EXTERNAL MODULE: ./src/components/PageHeader/PageHeaderDesktop.tsx + 12 modules
var PageHeaderDesktop = __webpack_require__(67834);
// EXTERNAL MODULE: ./src/components/Icon/IconTimer.tsx
var IconTimer = __webpack_require__(59542);
// EXTERNAL MODULE: ./src/components/Footer/index.tsx + 1 modules
var Footer = __webpack_require__(29128);
// EXTERNAL MODULE: ./src/components/Image/Image.tsx + 1 modules
var Image = __webpack_require__(72317);
;// CONCATENATED MODULE: ./src/modules/Blog/BlogArticleDetail.tsx


















const BlogArticleDetail = ({ slug , data  })=>{
    const [showAds, setShowAds] = (0,react.useState)(false);
    const [isShow, setShow] = (0,react.useState)(false);
    const [dataShare, setDataShare] = (0,react.useState)([]);
    const [contentBlog, setContentBlog] = (0,react.useState)([]);
    const router = (0,next_router.useRouter)();
    const showToast = (0,toastStore/* useToastStore */.E)((state)=>state.showToast);
    const blogArticleDetailApi = (0,blogApi/* useBlogArticleDetailApi */.q)(slug);
    // const data = blogArticleDetailApi.data?.data;
    const isHideHeader = router.query.hideHeader === "false";
    const isDesktop = (0,device/* useIsDesktop */.Ce)();
    (0,react.useEffect)(()=>{
        // blogArticleDetailApi.doFetch({ slug });
        if (!router.query.hideHeader) {
            if (router.pathname == "/blog/[blogSlug]") {
                // @ts-ignore
                router.push({
                    pathname: "/blog/[blogSlug]",
                    // pathname: router.pathname,
                    query: {
                        blogSlug: slug,
                        hideHeader: "false"
                    }
                });
            }
        }
    }, [
        router,
        slug
    ]);
    const onShare = ()=>{
        if (true) {
            if (window.screen.width > 481) {
                setShow(true);
            } else {
                if (navigator.canShare) {
                    navigator.share({
                        title: data?.title,
                        url: window.location.href
                    });
                }
            }
        }
    };
    const insertAt = (array, index, ...elementsArray)=>{
        return array.splice(index, 0, ...elementsArray);
    };
    (0,react.useEffect)(()=>{
        if (data) {
            // trackEvent({
            //   event: "blog_article_s",
            //   property: {
            //     blog_title: data?.title,
            //     blog_slug: data?.slug,
            //   },
            // });
            let paraArray = data?.content.split("</p>").flatMap((a)=>a.replace("\n", "<br />"));
            insertAt(paraArray, Math.floor(paraArray.length / 2), "in-ads");
            setContentBlog(paraArray);
            setDataShare((0,helper/* generateShareContent */.rT)(data, true));
        }
    }, [
        data
    ]);
    const propsModal = {
        title: "Bagikan Melalui",
        isShow,
        onClose: ()=>setShow(false),
        data: dataShare
    };
    const url = router.query.url;
    const renderContent = (elm)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-32 pt-36 w-[70%] m-auto xl-max:gap-0 xl-max:w-full xl-max:pt-8",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid gap-24 xl-max:gap-8 xl-max:p-16",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-h3 xl-max:text-h4 font-black",
                            children: elm?.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between items-center xl-max:flex-col xl-max:items-start xl-max:gap-20",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-neutral-60 font-medium flex gap-4 items-center text-b1 xl-max:text-c1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconTimer/* IconTimer */._, {
                                            size: 14
                                        }),
                                        (0,date/* toDDMMYYYYHHMM */.hk)(elm?.created_at, "long", false, true)
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare/* ModalShare */.x, {
                                    ...propsModal,
                                    useModal: false
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mb-64 xl-max:p-16 xl-max:mb-16 pt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            dangerouslySetInnerHTML: {
                                __html: contentBlog.map((a, index)=>{
                                    if (a == "in-ads") {
                                        {
                                        /*  Ad Slot Blog Center  */ }
                                        return `<div style="clear: both; text-align: center; margin: 10px;" key="center-of-blog" id="center-of-blog"><ins class="adsbygoogle" data-full-width-responsive="true" data-ad-format="auto" data-ad-client="ca-pub-9455978208365758" data-ad-slot="9094238882"></ins></div>`;
                                    } else {
                                        return a;
                                    }
                                }).join("<br>")
                            },
                            className: "wrap-article"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[50vh] w-full m-auto mb-16 xl-max:h-[207px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image.Image, {
                                src: elm?.image_url,
                                alt: elm?.title,
                                className: "w-full h-full rounded-2 overflow-hidden object-cover object-center my-16"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardAds/* CardAds */.M, {
                            slotId: "7398013833"
                        })
                    ]
                }),
                showAds && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-30 pb-[3rem]"
                }),
                showAds && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardSticky, {
                    classes: "flex items-center justify-center p-[1rem]",
                    full: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full p-[1rem] rounded-lg flex flex-col justify-center text-center text-white bg-neutral-60",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-flex-end mb-[-1rem]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "ml-auto bg-white rounded cursor-pointer z-10",
                                    onClick: ()=>setShowAds(!showAds),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconClose/* default */.Z, {
                                        size: 20
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "z-0",
                                children: "Sticky Placeholder"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "z-0",
                                children: "328x72"
                            })
                        ]
                    })
                })
            ]
        });
    };
    // if (isDesktop) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block xl-max:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeaderDesktop/* PageHeaderDesktop */._, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden xl-max:block",
                children: isHideHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* PageHeader */.m, {
                    withBackButton: true,
                    backTo: {
                        pathname: url && url == "blog" ? "/blog" : "/"
                    },
                    onShare: onShare
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* ContainerDesktop */.h, {
                className: "flex xl-max:w-full xl-max:m-0",
                children: renderContent(data)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
// } else {
//   return (
//     <Container className="min-h-screen">
//       {renderContent(data)}
//       <ModalShare {...propsModal} />
//     </Container>
//   );
// }
};


/***/ }),

/***/ 6153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useBlogArticlesApi; },
/* harmony export */   "q": function() { return /* binding */ useBlogArticleDetailApi; }
/* harmony export */ });
/* harmony import */ var lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49208);

const useBlogArticlesApi = ()=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/blog");
const useBlogArticleDetailApi = (additionalKey)=>(0,lib_apiFetcher__WEBPACK_IMPORTED_MODULE_0__/* .useApi */ .h_)("get", "/blog/{slug}", additionalKey);


/***/ })

}]);